export const novelPacksEn = {
  title: 'Novel works',
  filters: { status: 'Status', allStatuses: 'All statuses', search: 'Keyword', searchPlaceholder: 'Title, slug or creator email', apply: 'Search' },
  status: { draft: 'Draft', published: 'Published', unpublished: 'Unpublished', archived: 'Archived' },
  validation: { valid: 'Valid', invalid: 'Has errors' },
  listedInvalid: 'New runs will fail',
  listedInvalidHint: 'This listed work no longer passes the content check, so players who start a new run will get an error.',
  table: { title: 'Work', owner: 'Creator', latestVersion: 'Latest version', status: 'Status', validation: 'Content check', featured: 'Featured', updatedAt: 'Updated' },
  notFeatured: 'Not featured',
  noVersion: 'No version yet',
  emptyTitle: 'No novel works match the current filters.',
  actions: { preview: 'Preview', publish: 'Publish', unpublish: 'Unpublish', featured: 'Featured order' },
  publishConfirm: 'Publish “{title}”? Players will see it on the shelf and can start new runs right away.',
  blocked: { invalid: 'Fails the content check, cannot be published', archived: 'Archived, cannot be published' },
  unpublishConfirm: 'Unpublish this work? New players will no longer see it on the shelf; runs already in progress can keep going.',
  toast: {
    published: 'Published “{title}”.',
    unpublished: 'Unpublished “{title}”.',
    featuredSet: 'Featured order of “{title}” saved.',
    featuredCleared: '“{title}” is no longer featured.',
  },
  featuredForm: {
    title: 'Featured order',
    rank: 'Featured order',
    hint: 'A whole number, 0 or greater. Smaller numbers come first on the shelf. Clear it to take the work off the featured list.',
    clear: 'Clear featured',
    save: 'Save',
    invalid: 'Enter a whole number, 0 or greater.',
  },
  detail: {
    title: 'Work details',
    owner: 'Creator',
    language: 'Language',
    status: 'Status',
    currentVersion: 'Current version',
    validation: 'Content check',
    listedAt: 'Last listed',
    contentHash: 'Content hash',
    createdAt: 'Created',
    updatedAt: 'Updated',
    versions: 'Versions',
    noVersions: 'This work has no version yet.',
    assets: 'Assets',
    noAssets: 'No uploaded assets.',
    openingCg: { title: 'Opening CG', loadVersion: 'Load published version', assetKind: 'Asset type', video: 'Video MP4', poster: 'Poster JPG', captions: 'Captions VTT', file: 'File', upload: 'Upload asset' },
    close: 'Close',
    cover: 'Cover',
    teaser: 'Shelf teaser',
    characters: 'Characters',
    playerRole: 'Player',
    opening: 'Opening',
    empty: 'None',
    openStudio: 'Open in Studio',
    openStudioHint: 'Studio only opens a work for its creator.',
    openPlayer: 'View on player site',
    versionColumns: { version: 'Version', note: 'Note', validation: 'Content check', publishedAt: 'Published', hash: 'Package hash' },
    assetKinds: { cover: 'Cover', location: 'Location', state_image: 'State image', item: 'Item' },
  },
  release: {
    title: 'Release to production',
    hint: 'Push a version the creator cut on Stage to Main. Main creates or updates the work by slug, makes that version its current content and lists it; images are copied by object key. Runs, players and ledgers are never copied.',
    refresh: 'Refresh',
    stage: 'Stage',
    main: 'Main (production)',
    selectedVersion: 'Selected version',
    versionNote: 'Version note',
    cutAt: 'Cut at',
    connection: { connected: 'Connected', not_configured: 'Not configured', unreachable: 'Connection failed' },
    connectionHelp: { not_configured: 'Set SCENARIO_RELEASE_TARGET_URL and SCENARIO_RELEASE_TOKEN on Stage (the same token on Main), then restart the API.', unreachable: 'Stage could not reach Main. Check the target URL, the shared token and the API logs on both sides.' },
    mainVersion: 'Current version on Main',
    releasedAt: 'Last released',
    targetUrl: 'Target',
    notOnMain: 'Not on Main yet',
    noVersions: 'The creator has not cut a version yet. Versions are cut in Studio.',
    versionLabel: 'Version to release',
    noNote: 'No note',
    invalidVersion: 'This version no longer passes the content check, so Main would reject it.',
    sameVersion: 'Main already runs this version. Releasing it again re-syncs its content and images.',
    adminRequired: 'Only admins can release. Operators can view the status and records.',
    publish: 'Release to production',
    confirmTitle: 'Release to production?',
    confirmBody: 'Main will make {version} of “{title}” its current content and list it right away. Images that already exist on Main with the same hash are reused.',
    noUserData: 'Runs, players and ledgers are not copied.',
    progress: 'Releasing… keep this window open until it finishes.',
    confirm: 'Release',
    successTitle: 'Released to production',
    successSummary: '{version} is live on Main · {copied} uploaded, {reused} reused · {size} uploaded',
    historyTitle: 'Release records',
    historyEmpty: 'No releases yet.',
    operator: 'Operator',
    startedAt: 'Started',
    transfer: 'Images (uploaded / reused)',
    releaseId: 'Release ID',
    slugTaken: 'Main already has a work with the slug “{slug}” that a Main creator made. The release channel cannot overwrite it, so releasing is disabled.',
    reasonCodes: {
      FORBIDDEN: 'Main rejected the shared release token. SCENARIO_RELEASE_TOKEN must be the same on Stage and Main.',
      NOT_FOUND: 'Main does not have the novel release interface or record. Check that Main runs the same code version.',
    },
    logs: {
      locked: 'Locked Stage version {version} with {assets} objects',
      received: 'Received Stage version {version} with {assets} objects',
      sending: 'Sending the release bundle to production',
      syncing: 'Checking and syncing images',
      writing: 'Images synced ({copied} uploaded, {reused} reused); writing the work and version',
      switched: 'Production switched to {version}',
      failed: 'Failed: {reason}',
    },
    stale: {
      hint: 'This release has not moved for over 30 minutes; the API probably restarted mid-release. It blocks new releases of this work until you finish it as failed.',
      hintOperator: 'This release has not moved for over 30 minutes and blocks new releases of this work. Ask an admin to finish it.',
      finish: 'Finish as failed',
    },
    status: { prepared: 'Prepared', transferring: 'Transferring', applying: 'Applying', succeeded: 'Succeeded', failed: 'Failed' },
  },
  pager: { prev: 'Previous', next: 'Next', pageSize: 'Per page', summary: '{total} works · page {page} of {pages}' },
}

export const novelPacksZh = {
  title: '互动小说作品',
  filters: { status: '状态', allStatuses: '全部状态', search: '关键词', searchPlaceholder: '标题、短链名或创作者邮箱', apply: '搜索' },
  status: { draft: '草稿', published: '已上架', unpublished: '已下架', archived: '已归档' },
  validation: { valid: '通过', invalid: '有错误' },
  listedInvalid: '新开局会失败',
  listedInvalidHint: '这部已上架作品的内容已不再通过校验，玩家新开局会报错。',
  table: { title: '作品', owner: '创作者', latestVersion: '最新版本', status: '状态', validation: '内容校验', featured: '精选', updatedAt: '更新时间' },
  notFeatured: '未精选',
  noVersion: '还没有版本',
  emptyTitle: '没有符合条件的小说作品。',
  actions: { preview: '预览', publish: '上架', unpublish: '下架', featured: '精选序' },
  publishConfirm: '确认上架《{title}》？上架后玩家立即能在书架上看到它并开局。',
  blocked: { invalid: '内容未通过校验，不能上架', archived: '已归档，不能上架' },
  unpublishConfirm: '确认下架这部作品？新玩家将在书架上看不到它，已经开局的对局可以继续玩。',
  toast: {
    published: '已上架《{title}》。',
    unpublished: '已下架《{title}》。',
    featuredSet: '《{title}》的精选序已保存。',
    featuredCleared: '《{title}》已取消精选。',
  },
  featuredForm: {
    title: '精选序',
    rank: '精选序',
    hint: '填 0 或更大的整数，数字越小在书架上越靠前。清除后作品不再出现在精选里。',
    clear: '取消精选',
    save: '保存',
    invalid: '请输入 0 或更大的整数。',
  },
  detail: {
    title: '作品详情',
    owner: '创作者',
    language: '语言',
    status: '状态',
    currentVersion: '当前版本',
    validation: '内容校验',
    listedAt: '最近上架',
    contentHash: '内容哈希',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    versions: '版本',
    noVersions: '这部作品还没有版本。',
    assets: '素材',
    noAssets: '没有上传过素材。',
    openingCg: { title: '开场 CG', loadVersion: '载入已上架冻结版本', assetKind: '素材类型', video: '视频 MP4', poster: '海报 JPG', captions: '字幕 VTT', file: '文件', upload: '上传素材' },
    close: '关闭',
    cover: '封面',
    teaser: '书架简介',
    characters: '人物',
    playerRole: '玩家角色',
    opening: '开场正文',
    empty: '暂无',
    openStudio: '在创作台打开',
    openStudioHint: '创作台只对作品创作者本人开放。',
    openPlayer: '在玩家端查看',
    versionColumns: { version: '版本', note: '说明', validation: '内容校验', publishedAt: '发布时间', hash: '包哈希' },
    assetKinds: { cover: '封面', location: '地点图', state_image: '状态图', item: '物品图' },
  },
  release: {
    title: '发布到正式环境',
    hint: '把作者在 Stage 切出的版本推到 Main：Main 按短链名建或更新作品，把该版本设为当前内容并上架，图片按对象键增量搬运。对局、玩家、账本一律不发。',
    refresh: '刷新',
    stage: 'Stage',
    main: 'Main（正式环境）',
    selectedVersion: '选中版本',
    versionNote: '版本说明',
    cutAt: '切出时间',
    connection: { connected: '连接正常', not_configured: '尚未配置', unreachable: '连接失败' },
    connectionHelp: { not_configured: '在 Stage 配置 SCENARIO_RELEASE_TARGET_URL 与 SCENARIO_RELEASE_TOKEN（Main 配同一个凭据）后重启 API。', unreachable: 'Stage 连不上 Main。检查目标地址、共享凭据与两端 API 日志。' },
    mainVersion: 'Main 当前版本',
    releasedAt: '最近发布',
    targetUrl: '目标地址',
    notOnMain: 'Main 还没有这部作品',
    noVersions: '作者还没有切出版本，版本在创作台切出。',
    versionLabel: '要发布的版本',
    noNote: '没有说明',
    invalidVersion: '这个版本按当前规则校验不通过，Main 会拒收。',
    sameVersion: 'Main 已在用这个版本，再次发布会重新同步内容与图片。',
    adminRequired: '只有管理员可以发布，运营只能查看状态与记录。',
    publish: '发布到正式环境',
    confirmTitle: '确认发布到正式环境？',
    confirmBody: 'Main 会把《{title}》的 {version} 设为当前内容并立即上架；Main 上已有且哈希一致的图片直接复用。',
    noUserData: '对局、玩家、账本不会被发布。',
    progress: '发布中…完成前请不要关闭窗口。',
    confirm: '确认发布',
    successTitle: '已发布到正式环境',
    successSummary: '{version} 已在 Main 生效 · 新上传 {copied} 个，复用 {reused} 个 · 上传 {size}',
    historyTitle: '发布记录与日志',
    historyEmpty: '还没有发布记录。',
    operator: '操作人',
    startedAt: '开始时间',
    transfer: '图片（新上传 / 复用）',
    releaseId: '发布编号',
    slugTaken: 'Main 上已有短链名为“{slug}”、由 Main 创作者自建的作品，发布通道不会覆盖它，已禁用发布。',
    reasonCodes: {
      FORBIDDEN: 'Main 拒绝了共享发布凭据：Stage 与 Main 的 SCENARIO_RELEASE_TOKEN 必须一致。',
      NOT_FOUND: 'Main 没有互动小说发布接口或这条记录，请确认 Main 部署的是同一版代码。',
    },
    logs: {
      locked: '已锁定 Stage 版本 {version}，{assets} 个对象',
      received: '已接收 Stage 版本 {version}，{assets} 个对象',
      sending: '开始向正式环境发送发布包',
      syncing: '开始校验并同步作品图片',
      writing: '图片同步完成（新上传 {copied}，复用 {reused}），开始写入作品与版本',
      switched: '正式环境已切换到 {version}',
      failed: '失败：{reason}',
    },
    stale: {
      hint: '这次发布超过 30 分钟没有推进，多半是 API 在发布中重启了；它会一直挡住这部作品的新发布，收尾成失败后才能再发。',
      hintOperator: '这次发布超过 30 分钟没有推进，会挡住这部作品的新发布，请管理员收尾。',
      finish: '收尾为失败',
    },
    status: { prepared: '已准备', transferring: '传输中', applying: '写入中', succeeded: '已成功', failed: '失败' },
  },
  pager: { prev: '上一页', next: '下一页', pageSize: '每页条数', summary: '共 {total} 部 · 第 {page} / {pages} 页' },
}
